import { render, staticRenderFns } from "./FormGemeos.vue?vue&type=template&id=1cc6a05a&"
import script from "./FormGemeos.vue?vue&type=script&lang=js&"
export * from "./FormGemeos.vue?vue&type=script&lang=js&"
import style0 from "./FormGemeos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports